module.exports = __webpack_public_path__ + "static/media/BG.b3624386.webp";